import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import Translate from 'react-translate-component';

import { getScenario } from 'actions/asyncActions';

import { CMD, OBJTYPE } from 'constants/scenario';
import { fullAutoOptions } from 'constants/asyncClient';
import ScenarioInfo from 'components/views/education/scenario/ScenarioInfo';
import SidebarContainer from '../../SidebarContainer';
import { scenario } from 'constants/routes';
import CustomIcon from 'components/common/CustomIcon';

@withAsyncActions({
    getScenario: getScenario
        .withParams(({ id }) => id)
        .withPayload(({ id }) => ({ cmd: CMD, objtype: OBJTYPE, objkey: id }))
}, fullAutoOptions)
export default class ScenarioSidebarView extends Component {
    static propTypes = {
        getScenario: PropTypes.object.isRequired,
        params: PropTypes.object,
        id: PropTypes.number.isRequired
    }

    renderFooter() {
        const { id } = this.props;

        return (
            <Button href={`#${scenario.stringify({ id })}`}>
                <CustomIcon type="list-ul" />
                <Translate content="education.scenario.toScenario" />
            </Button>
        )
    }

    render() {
        const { meta, data, refresh } = this.props.getScenario;
        const { title } = this.props.params;

        return (
            <SidebarContainer title={title} disableLock={true} meta={meta} refresh={refresh} footer={this.renderFooter()}>
                <ScenarioInfo info={data} />
            </SidebarContainer>
        )
    }
}
